import { render, staticRenderFns } from "./notificationManager.vue?vue&type=template&id=28038043&scoped=true"
import script from "./notificationManager.vue?vue&type=script&lang=js"
export * from "./notificationManager.vue?vue&type=script&lang=js"
import style0 from "./notificationManager.vue?vue&type=style&index=0&id=28038043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28038043",
  null
  
)

export default component.exports